module.exports = __webpack_public_path__ + "img/appointment_icon.f582a110.svg";